import React from "react";

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;    
}

const Pagination: React.FC<PaginationProps> = ({ totalPages , currentPage , setCurrentPage}) => {
  return (
   <div className="flex justify-between items-center gap-2 mt-6 w-full">
          <div className="flex gap-2">
            {[...Array(totalPages)].map((_, idx) => (
              <button
                key={idx + 1}
                className={`px-3 py-1 rounded border border-gray-500 text-sm ${
                  currentPage === idx + 1
                    ? "bg-gray-400 text-black"
                    : "bg-transparent text-white hover:bg-gray-800"
                }`}
                onClick={() => setCurrentPage(idx + 1)}
              >
                {idx + 1}
              </button>
            ))}
          </div>
          <div className="flex gap-2">
            {currentPage !== 1 && (
              <button
                className="px-3 py-1 rounded border border-gray-500 text-sm bg-transparent text-white hover:bg-gray-800"
                onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
              >
                Previous
              </button>
            )}
            {currentPage !== totalPages && (
              <button
                className="px-3 py-1 rounded border border-gray-500 text-sm bg-transparent text-white hover:bg-gray-800"
                onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
              >
                Next
              </button>
            )}
          </div>
        </div>
  );
}
export default Pagination;